<template>
  <el-card>
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="规章制度主题:" >
        <el-input v-model="searchFactor.theme"></el-input>
      </el-form-item>
      <el-form-item label="规章制度区域:" >
        <el-select v-model="searchFactor.type" placeholder="请选择" style="width:200px">
          <el-option  label= "全部" value="" ></el-option>
          <el-option
            v-for="item in regScopeList"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实验室准入教程:" >
        <el-select v-model="searchFactor.basicState" placeholder="请选择" style="width:200px">
          <el-option  label= "全部" value="" ></el-option>
          <el-option  label= "是" value="1" ></el-option>
          <el-option  label= "否" value="0" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateReg">创建</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      height="calc(100vh - 200px)"
      :max-height="800"
      :highlight-current-row ="true"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="type"
        label="区域"
        min-width="70" >
      </el-table-column>
      <el-table-column
        prop="basicState"
        label="实验室准入教程"
        min-width="70">
        <template slot-scope="scope">
          <span v-if = "scope.row.basicState == 1" style="color: greenyellow"> 是</span>
          <span v-else style="color: red" > 否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="theme"
        label="主题"
        min-width="100" >
      </el-table-column>
      <el-table-column
        prop="content"
        label="内容"
        min-width="250" :formatter="formatContent">
      </el-table-column>
      <el-table-column
        prop="initFolderName"
        label="资源文件夹"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="attachFileName"
        label="附件名称"
        min-width="150">
      </el-table-column>
      <el-table-column
      prop="active"
      width="70"
      label="状态" >
      <template slot-scope="scope">
          <span v-if = "scope.row.active == 0" style="color: red"> 未发布</span>
          <span v-else style="color: greenyellow" > 已发布</span>
      </template>
    </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="100">
      </el-table-column>
      <el-table-column
        prop="updateUser"
        width="120"
        label="更新者">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        width="100"
        label="更新时间">
      </el-table-column>
      <el-table-column label="操作" min-width="120px">
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"doActiveReg",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 0 ? 'el-icon-star-on':'el-icon-star-off' "  :style="scope.row.active == 0 ?'color:rgb(40, 238, 10)' :'color:rgb(246, 102, 18)'" ></i> 
                <span>{{scope.row.active == 0?'发布':'撤销'}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleViewReg",index:scope.$index, data:scope.row}'> <i class="el-icon-search" style="color:rgb(39, 193, 231)" ></i> <span>预览</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleEditReg",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(41, 10, 239)" ></i> <span>编辑</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"uploadAttach", index:scope.$index,data:scope.row}'><i class="el-icon-upload2" style="color:rgb(40, 238, 10)" ></i> <span>上传附件</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDeleteAttach",index:scope.$index, data:scope.row}'><i class="el-icon-delete" style="color:rgb(247, 33, 40)" ></i> <span>删除附件</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDelete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next"
      :current-page.sync="pager.currentPage"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount"
      >
    </el-pagination>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.initRegThemeVisual" v-on:close ="clearInitRegForm" >
      <div slot="title" class="dialog-footer">
          <span> 创建规章制度 </span>
      </div>
      <el-form  :model="initRegForm" label-width="20%">
        <el-form-item  label="规章制度主题:" style="width: 80%">
          <el-input v-model="initRegForm.theme" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item  label="规章制度区域:" style="width: 80%">
          <el-select v-model="initRegForm.type" placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in regScopeList"
              :key="item.id"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实验室准入教程:" style="width: 80%">
          <el-checkbox v-model="initRegForm.basicState"></el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建</el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" width="40%" :visible.sync="dialogVisual.initUploadAttachVisual" v-on:close ="clearUplaodAttachForm" >
      <div slot="title" class="dialog-footer">
        <span> 上传附件 </span>
      </div>
      <el-upload
        style="display: inline-block"
        ref='uploadAttach'
        :action="regAttach.url"
        :headers="regAttach.headers"
        :multiple="false"
        :limit="regAttach.limit"
        :name="regAttach.file"
        :on-success="fileUpLoadSuccess"
        :show-file-list="true"
        :on-error="fileUpLoadError">
        <el-button  size="mini"  @click="handleUploadAttach()">添加附件</el-button>
      </el-upload>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
  import axios from  '@/api/axiosConfig'
  import SERVICE_URL  from  '@/api/url'

  import {stringIsNullOrEmpty,getToken} from  '@/api/utils'
  import {PAGE_SIZE,MESSAGE_DURATION,fileType,fileAreaType} from  '@/api/constant'
  export default {
    name : 'pc_ctr_reg_list',
    data() {
    return {
      searchFactor: {
        theme: '',
        type: '',
        basicState :'',
      },
      regScopeList:[],
      dialogVisual:{
        initRegThemeVisual: false,
        initUploadAttachVisual:false
      },
      initRegForm:{
        theme:'',
        type: '',
        basicState : false
      },
      regAttach :{
        headers: {token:""},
        url : "",
        limit : 1,
        name :"file",
        id:""
      },
      tableData: [],
      pager:{
        currentPage:0,
        totalCount:0,
        pageSize : PAGE_SIZE
      }
    }
  },
  methods : {
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'handleDelete' :
            this.handleDelete(index,row)
            break
        case 'handleDeleteAttach' :
            this.handleDeleteAttach(index,row)
            break
        case 'handleEditReg' :
            // this.handleEditNotice(index,row)
            let left =  (window.screen.availWidth-10-1000)/2
            let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
            width=1000,height=1000,left=${left},top=100`;
            window.open(SERVICE_URL +"/#/pc_ctr_reg_edit/" +row.id,"test",params);
            break
        case 'handleViewReg':
            //this.handleViewNotice(index,row)
            // this.handleEditNotice(index,row)
            let left0 =  (window.screen.availWidth-10-1000)/2
            let params0 = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
            width=1000,height=1000,left=${left0},top=100`;
            window.open(SERVICE_URL+ "/#/pc_ctr_editor_view/"
             +row.id +"?fileType=" + 
             fileType.REGULATIONS.NAME  + "&subType="  + row.type ,"通知公告预览",params0);
            break
        case 'doActiveReg':
            this.doActiveReg(index,row)
            break
        case 'uploadAttach':
            this.uploadAttach(index,row)
            break
      }
    },
    uploadAttach(index,row){
      this.dialogVisual.initUploadAttachVisual = true
      this.regAttach.id = row.id
    },
    indexMethod(index){
        return  index + 1
    },
    handleUploadAttach(){
      this.regAttach.url = "/bc/exa/reg/upload?id=" + this.regAttach.id + "&fileArea="+  fileAreaType.ATTACH
    },
    fileUpLoadSuccess(response, file, fileList){
      this.$refs.uploadAttach.clearFiles()
      if(response.code === 0){
        this.$message({
          showClose: true,
          message: '上传成功!',
          type: 'success',
          duration: MESSAGE_DURATION
        })
      }else{
        this.$message({
          showClose: true,
          message: response.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      }
    },
    fileUpLoadError(err, file, fileList){
      this.$refs.uploadAttach.clearFiles();
      this.$message({
        showClose: true,
        message: err,
        type: 'error',
        duration: MESSAGE_DURATION
      })
    },
    formatContent(row , index){
      if(row.content == null || row.content == ''){
        return ''
      }
      if(row.content.length > 400 ){
        return row.content.substring(0,400)
      }
      return row.content
    },
    handleCurrentChange(val){
      this.editorListLoad(val);
    },
    regListLoad(pageNo){
      let url = "/bc/exa/reg/regPage"
      let { 
          theme,
          type,
          basicState

      } = this.searchFactor 
      let dat0 = {
          pageSize: PAGE_SIZE,
          theme,
          pageNo,
          type,
          basicState
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
              this.tableData = [];
              dat.data.forEach(t=>this.tableData.push(t))
              this.pager.totalCount = dat.totalDataCount
              if(pageNo == 1 ) {
                this.pager.currentPage = 1
              }
          } else {
            this.$message({
              showClose: true,
              message: '未查询到规章制度信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },
    onSearch(){
      this.regListLoad(1)
    },
    handleCreateReg(){
      this.dialogVisual.initRegThemeVisual = true;
    },
    handleViewEditor(index, row){
      this.$router.replace({ path:'pc_ctr_editor_view', query: {id: row.id}} )
    },
    handleDelete(index, row){
      this.$confirm('即将删除主题['+row.theme+']的规章制度!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteReg(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },

    clearUplaodAttachForm (){
      this.regAttach.id = ''
      this.regAttach.url= ""
    },
    doDeleteReg(row){
      let datBat = {id: row.id}
      let url = "/bc/exa/reg/regDelete"
      let s = JSON.stringify(datBat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.regListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleDeleteAttach(index, row){
      this.$confirm('即将删除主题['+row.theme+']的附件!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteRegAttach(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteRegAttach(row){
      let dat = {id: row.id}
      let url = "/bc/exa/reg/deleteAttach"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{
            this.regListLoad(1)
          },200)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    doActiveReg(index,row){
      let actState = row.active === 0 ? 1 : 0
      let dat = {
        id: row.id,
        active: actState
      }
      let url = "/bc/exa/reg/regActive"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '操作成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.regListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    handleRegEditor(index,row){
      this.$router.replace({ path:'pc_ctr_reg_change',query: {id: row.id, fileType : fileType.NOTICE_FILE} })
    },
    ensureCreate(){
      let{ theme,type,basicState} = this.initRegForm;

      
      try{ 
        stringIsNullOrEmpty(theme,'请输入规章制度主题!');
        stringIsNullOrEmpty(type,'请输入规章制度作用区域!');
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      let dat = {
        theme ,
        type,
        basicState : basicState ? 1: 0
      }
      let url = "/bc/exa/reg/save"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.initRegThemeVisual = false;
          this.$message({
            showClose: true,
            message: '创建规章制度成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.clearInitRegForm();
          setTimeout(()=>{
            this.regListLoad(1);
          },200);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err)=> {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    clearInitRegForm(){
      this.initRegForm.theme = ''
      this.initRegForm.type = ''
      this.initRegForm.basicState = false

      //  this.regAttach.id = ''
    }
  },
  created () {
    
    setTimeout(()=>{getToken(this.regAttach.headers)},200)
    let subType = fileType.REGULATIONS.SUB_TYPE
    this.regScopeList = []
    this.regScopeList.push({id :1, value : subType.COUNTRY, label :subType.COUNTRY})
    this.regScopeList.push({id :2, value : subType.LOCAL , label :subType.LOCAL  })
    this.regScopeList.push({id :3, value : subType.OTHER , label :subType.OTHER  })
    this.regListLoad(1);
  },
  components: {
    
  }
}
</script>
    
<style lang="less" scoped>
 .el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_reg_list.vue